import React from 'react';
import { ITab } from './Tab';

const TabsContext = React.createContext({
  context: {
    prevActiveTab: {},
    activeTab: { id: null, },
    tabs: [],
    addTab: (_tab: ITab) => {},
    removeTab: (_tabId: number | string) => {},
    onClick: (_tab: ITab) => {}
  },
});

interface IProps {
  activeTab: ITab;
  [key: string]: any;
}

class TabsProvider extends React.Component<IProps> {
  state: any = {
    tabs: [],
    prevActiveTab: {},
    activeTab: this.props.activeTab,
  };

  addTab = (tab: ITab) => {
    const isTabExist = this.state.tabs.find((t: ITab) => tab.id === t.id);

    if (!isTabExist) {
      console.log(this.state.tabs, tab);
      this.setState((prevState: any) => ({
        tabs: [...prevState.tabs, tab],
      }));
    }
  };

  removeTab = (tabId: number | string) => {
    this.setState((prevState: any) => ({
      tabs: prevState.tabs.filter((tab: ITab) => tab.id !== tabId),
    }));
  };

  onClick = (tab: ITab) => () => {
    this.setState((prevState: any) => ({
      prevActiveTab: prevState.activeTab,
      activeTab: tab,
    }));
  };

  render() {
    return (
      <TabsContext.Provider
        value={{
          context: {
            ...this.state,
            tabs: [...this.state.tabs],
            addTab: this.addTab,
            removeTab: this.removeTab,
            onClick: this.onClick,
          },
        }}
      >
        {this.props.children}
      </TabsContext.Provider>
    );
  }
}

const TabsConsumer = TabsContext.Consumer;

export { TabsProvider, TabsContext, TabsConsumer };
